import { RelatedToType } from '@shared/enums';

export enum NewPermission {
  SETTINGS_CALENDAR_ACCESS = 'SETTINGS_CALENDAR_ACCESS',
  SETTINGS_MANAGE_WORKSPACE = 'SETTINGS_MANAGE_WORKSPACE',
  SETTINGS_MANAGE_USERS = 'SETTINGS_MANAGE_USERS',
  SETTINGS_MANAGE_TEAMS = 'SETTINGS_MANAGE_TEAMS',
  SETTINGS_MANAGE_PERMISSIONS = 'SETTINGS_MANAGE_PERMISSIONS',
  SETTINGS_MANAGE_ROLES = 'SETTINGS_MANAGE_ROLES',
  SETTINGS_MANAGE_DROPDOWNS = 'SETTINGS_MANAGE_DROPDOWNS',
  SETTINGS_MANAGE_OBJECTS_MANAGER = 'SETTINGS_MANAGE_OBJECTS_MANAGER',
  SETTINGS_MANAGE_FIELDS = 'SETTINGS_MANAGE_FIELDS',
  SETTINGS_MANAGE_TASK_TEMPLATES = 'SETTINGS_MANAGE_TASK_TEMPLATES',
  SETTINGS_MANAGE_SHEETS = 'SETTINGS_MANAGE_SHEETS',
  SETTINGS_MANAGE_APPS = 'SETTINGS_MANAGE_APPS',
  SETTINGS_MANAGE_CODE = 'SETTINGS_MANAGE_CODE',
  SETTINGS_MANAGE_IMPORTS = 'SETTINGS_MANAGE_IMPORTS',
  SETTINGS_MANAGE_AUTOMATIONS = 'SETTINGS_MANAGE_AUTOMATIONS',
  SETTINGS_MANAGE_EXPORTS = 'SETTINGS_MANAGE_EXPORTS',
  SETTINGS_MANAGE_ACCOUNT_HOOKS = 'SETTINGS_MANAGE_ACCOUNT_HOOKS',
  SETTINGS_MANAGE_LAYOUTS = 'SETTINGS_MANAGE_LAYOUTS',
  SETTINGS_MANAGE_AUDIT = 'SETTINGS_MANAGE_AUDIT',
  SETTINGS_MANAGE_FOLDER_RESOURCE_TEMPLATES = 'SETTINGS_MANAGE_FOLDER_RESOURCE_TEMPLATES',
  SETTINGS_MANAGE_BUDGET_BUILDER_TEMPLATES = 'SETTINGS_MANAGE_BUDGET_BUILDER_TEMPLATES',

  DEALS_VIEW = 'DEALS_VIEW',
  DEALS_CREATE = 'DEALS_CREATE',
  DEALS_EDIT = 'DEALS_EDIT',
  DEALS_DELETE = 'DEALS_DELETE',
  DEALS_MANAGE_ADD_FORM = 'DEALS_MANAGE_ADD_FORM',
  DEALS_MANAGE_LAYOUT = 'DEALS_MANAGE_LAYOUT',
  DEALS_PUBLIC_CUSTOM_VIEWS = 'DEALS_PUBLIC_CUSTOM_VIEWS',
  DEALS_SHARING_RECORDS = 'DEALS_SHARING_RECORDS',
  DEALS_MANAGE_APPROVALS = 'DEALS_MANAGE_APPROVALS',

  PROPERTIES_VIEW = 'PROPERTIES_VIEW',
  PROPERTIES_CREATE = 'PROPERTIES_CREATE',
  PROPERTIES_EDIT = 'PROPERTIES_EDIT',
  PROPERTIES_DELETE = 'PROPERTIES_DELETE',
  PROPERTIES_MANAGE_ADD_FORM = 'PROPERTIES_MANAGE_ADD_FORM',
  PROPERTIES_MANAGE_LAYOUT = 'PROPERTIES_MANAGE_LAYOUT',
  PROPERTIES_PUBLIC_CUSTOM_VIEWS = 'PROPERTIES_PUBLIC_CUSTOM_VIEWS',
  PROPERTIES_SHARING_RECORDS = 'PROPERTIES_SHARING_RECORDS',
  PROPERTIES_MANAGE_APPROVALS = 'PROPERTIES_MANAGE_APPROVALS',

  LOAN_QUOTES_VIEW = 'LOAN_QUOTES_VIEW',
  LOAN_QUOTES_CREATE = 'LOAN_QUOTES_CREATE',
  LOAN_QUOTES_EDIT = 'LOAN_QUOTES_EDIT',
  LOAN_QUOTES_DELETE = 'LOAN_QUOTES_DELETE',
  LOAN_QUOTES_MANAGE_ADD_FORM = 'LOAN_QUOTES_MANAGE_ADD_FORM',
  LOAN_QUOTES_MANAGE_LAYOUT = 'LOAN_QUOTES_MANAGE_LAYOUT',
  LOAN_QUOTES_PUBLIC_CUSTOM_VIEWS = 'LOAN_QUOTES_PUBLIC_CUSTOM_VIEWS',
  LOAN_QUOTES_SHARING_RECORDS = 'LOAN_QUOTES_SHARING_RECORDS',

  LEASES_VIEW = 'LEASES_VIEW',
  LEASES_CREATE = 'LEASES_CREATE',
  LEASES_EDIT = 'LEASES_EDIT',
  LEASES_DELETE = 'LEASES_DELETE',
  LEASES_MANAGE_ADD_FORM = 'LEASES_MANAGE_ADD_FORM',
  LEASES_MANAGE_LAYOUT = 'LEASES_MANAGE_LAYOUT',
  LEASES_PUBLIC_CUSTOM_VIEWS = 'LEASES_PUBLIC_CUSTOM_VIEWS',
  LEASES_SHARING_RECORDS = 'LEASES_SHARING_RECORDS',
  LEASES_MANAGE_APPROVALS = 'LEASES_MANAGE_APPROVALS',

  DISPOSITIONS_VIEW = 'DISPOSITIONS_VIEW',
  DISPOSITIONS_CREATE = 'DISPOSITIONS_CREATE',
  DISPOSITIONS_EDIT = 'DISPOSITIONS_EDIT',
  DISPOSITIONS_DELETE = 'DISPOSITIONS_DELETE',
  DISPOSITIONS_MANAGE_ADD_FORM = 'DISPOSITIONS_MANAGE_ADD_FORM',
  DISPOSITIONS_MANAGE_LAYOUT = 'DISPOSITIONS_MANAGE_LAYOUT',
  DISPOSITIONS_PUBLIC_CUSTOM_VIEWS = 'DISPOSITIONS_PUBLIC_CUSTOM_VIEWS',
  DISPOSITIONS_SHARING_RECORDS = 'DISPOSITIONS_SHARING_RECORDS',

  FILES_VIEW = 'FILES_VIEW',
  FILES_CREATE = 'FILES_CREATE',
  FILES_EDIT = 'FILES_EDIT',
  FILES_DELETE = 'FILES_DELETE',
  FILES_SHARING_RECORDS = 'FILES_SHARING_RECORDS',

  COMPANIES_VIEW = 'COMPANIES_VIEW',
  COMPANIES_CREATE = 'COMPANIES_CREATE',
  COMPANIES_EDIT = 'COMPANIES_EDIT',
  COMPANIES_DELETE = 'COMPANIES_DELETE',
  COMPANIES_MANAGE_ADD_FORM = 'COMPANIES_MANAGE_ADD_FORM',
  COMPANIES_MANAGE_LAYOUT = 'COMPANIES_MANAGE_LAYOUT',
  COMPANIES_PUBLIC_CUSTOM_VIEWS = 'COMPANIES_PUBLIC_CUSTOM_VIEWS',
  COMPANIES_SHARING_RECORDS = 'COMPANIES_SHARING_RECORDS',
  COMPANIES_MANAGE_APPROVALS = 'COMPANIES_MANAGE_APPROVALS',

  CONTACTS_VIEW = 'CONTACTS_VIEW',
  CONTACTS_CREATE = 'CONTACTS_CREATE',
  CONTACTS_EDIT = 'CONTACTS_EDIT',
  CONTACTS_DELETE = 'CONTACTS_DELETE',
  CONTACTS_MANAGE_ADD_FORM = 'CONTACTS_MANAGE_ADD_FORM',
  CONTACTS_MANAGE_LAYOUT = 'CONTACTS_MANAGE_LAYOUT',
  CONTACTS_PUBLIC_CUSTOM_VIEWS = 'CONTACTS_PUBLIC_CUSTOM_VIEWS',
  CONTACTS_SHARING_RECORDS = 'CONTACTS_SHARING_RECORDS',
  CONTACTS_MANAGE_APPROVALS = 'CONTACTS_MANAGE_APPROVALS',

  ENGAGEMENTS_VIEW = 'ENGAGEMENTS_VIEW',
  ENGAGEMENTS_CREATE = 'ENGAGEMENTS_CREATE',
  ENGAGEMENTS_EDIT = 'ENGAGEMENTS_EDIT',
  ENGAGEMENTS_DELETE = 'ENGAGEMENTS_DELETE',
  ENGAGEMENTS_MANAGE_ADD_FORM = 'ENGAGEMENTS_MANAGE_ADD_FORM',
  ENGAGEMENTS_MANAGE_LAYOUT = 'ENGAGEMENTS_MANAGE_LAYOUT',
  ENGAGEMENTS_PUBLIC_CUSTOM_VIEWS = 'ENGAGEMENTS_PUBLIC_CUSTOM_VIEWS',
  ENGAGEMENTS_SHARING_RECORDS = 'ENGAGEMENTS_SHARING_RECORDS',

  GLOBAL_TASK_LISTS_VIEW = 'GLOBAL_TASK_LISTS_VIEW',
  GLOBAL_TASK_LISTS_CREATE = 'GLOBAL_TASK_LISTS_CREATE',
  GLOBAL_TASK_LISTS_EDIT = 'GLOBAL_TASK_LISTS_EDIT',
  GLOBAL_TASK_LISTS_DELETE = 'GLOBAL_TASK_LISTS_DELETE',
  GLOBAL_TASK_LISTS_MANAGE_ADD_FORM = 'GLOBAL_TASK_LISTS_MANAGE_ADD_FORM',
  GLOBAL_TASKS_SHARING_RECORDS = 'GLOBAL_TASKS_SHARING_RECORDS',

  AGGREGATED_TASK_LISTS_VIEW = 'AGGREGATED_TASK_LISTS_VIEW',
  AGGREGATED_TASK_LISTS_CREATE = 'AGGREGATED_TASK_LISTS_CREATE',
  AGGREGATED_TASK_LISTS_EDIT = 'AGGREGATED_TASK_LISTS_EDIT',
  AGGREGATED_TASK_LISTS_DELETE = 'AGGREGATED_TASK_LISTS_DELETE',
  AGGREGATED_TASK_LISTS_MANAGE_ADD_FORM = 'AGGREGATED_TASK_LISTS_MANAGE_ADD_FORM',
  AGGREGATED_TASKS_PUBLIC_CUSTOM_VIEWS = 'AGGREGATED_TASKS_PUBLIC_CUSTOM_VIEWS',
  AGGREGATED_TASKS_SHARING_RECORDS = 'AGGREGATED_TASKS_SHARING_RECORDS',

  DASHBOARDS_CREATE = 'DASHBOARDS_CREATE',
  DASHBOARDS_VIEW = 'DASHBOARDS_VIEW',
  DASHBOARDS_EDIT = 'DASHBOARDS_EDIT',
  DASHBOARDS_DELETE = 'DASHBOARDS_DELETE',
  DASHBOARDS_SHARING_RECORDS = 'DASHBOARDS_SHARING_RECORDS',

  REPORT_BUILDER_CREATE = 'REPORT_BUILDER_CREATE',
  REPORTS_BUILDER_VIEW = 'REPORTS_BUILDER_VIEW',
  REPORTS_BUILDER_EDIT = 'REPORTS_BUILDER_EDIT',
  REPORTS_BUILDER_DELETE = 'REPORTS_BUILDER_DELETE',
  REPORT_BUILDER_SHARING_RECORDS = 'REPORT_BUILDER_SHARING_RECORDS',

  PDF_REPORTS_CREATE = 'PDF_REPORTS_CREATE',
  PDF_REPORTS_VIEW = 'PDF_REPORTS_VIEW',
  PDF_REPORTS_EDIT = 'PDF_REPORTS_EDIT',
  PDF_REPORTS_DELETE = 'PDF_REPORTS_DELETE',
  PDF_REPORTS_SHARING_RECORDS = 'PDF_REPORTS_SHARING_RECORDS',

  BUDGETS_VIEW = 'BUDGETS_VIEW',
  BUDGETS_CREATE = 'BUDGETS_CREATE',
  BUDGETS_EDIT = 'BUDGETS_EDIT',
  BUDGETS_DELETE = 'BUDGETS_DELETE',
  BUDGETS_APPROVE = 'BUDGETS_APPROVE',
}

export enum Module {
  DASHBOARDS = 'DASHBOARDS',
  DEALS = 'DEALS',
  CONTACTS = 'CONTACTS',
  TASKS = 'TASKS',
  GLOBAL_TASKS = 'GLOBAL_TASKS',
  AGGREGATED_TASKS = 'AGGREGATED_TASKS',
  PROPERTIES = 'PROPERTIES',
  MAPS = 'MAPS',
  REPORTS = 'REPORTS',
  SETTINGS = 'SETTINGS',
  LEASES = 'LEASES',
  DISPOSITIONS = 'DISPOSITIONS',
  LOAN_QUOTES = 'LOAN_QUOTES',
  CUSTOM_OBJECTS = 'CUSTOM_OBJECTS',
  COMPANIES = 'COMPANIES',
  ETHAN = 'ETHAN',
}

export const ModuleRelatedToMap = {
  [Module.COMPANIES]: RelatedToType.Company,
  [Module.CONTACTS]: RelatedToType.Contact,
  [Module.PROPERTIES]: RelatedToType.Property,
  [Module.DEALS]: RelatedToType.Project,
};

export enum ReservedRole {
  Admin = 'admin',
  Collaborator = 'collaborator',
  Limited = 'limited',
  Standard = 'standard',
}

export const ModuleNewPermission: Record<Module, NewPermission[]> = {
  [Module.GLOBAL_TASKS]: [
    NewPermission.GLOBAL_TASKS_SHARING_RECORDS,
    NewPermission.GLOBAL_TASK_LISTS_DELETE,
    NewPermission.GLOBAL_TASK_LISTS_CREATE,
    NewPermission.GLOBAL_TASK_LISTS_EDIT,
    NewPermission.GLOBAL_TASK_LISTS_MANAGE_ADD_FORM,
    NewPermission.GLOBAL_TASK_LISTS_VIEW,
  ],
  [Module.AGGREGATED_TASKS]: [
    NewPermission.AGGREGATED_TASKS_PUBLIC_CUSTOM_VIEWS,
    NewPermission.AGGREGATED_TASK_LISTS_MANAGE_ADD_FORM,
    NewPermission.AGGREGATED_TASK_LISTS_EDIT,
    NewPermission.AGGREGATED_TASK_LISTS_DELETE,
    NewPermission.AGGREGATED_TASK_LISTS_CREATE,
    NewPermission.AGGREGATED_TASKS_SHARING_RECORDS,
    NewPermission.AGGREGATED_TASK_LISTS_VIEW,
  ],
  [Module.DASHBOARDS]: [
    NewPermission.DASHBOARDS_CREATE,
    NewPermission.DASHBOARDS_EDIT,
    NewPermission.DASHBOARDS_SHARING_RECORDS,
    NewPermission.DASHBOARDS_VIEW,
    NewPermission.DASHBOARDS_DELETE,
  ],
  [Module.DEALS]: [NewPermission.DEALS_VIEW],
  [Module.LOAN_QUOTES]: [
    NewPermission.LOAN_QUOTES_VIEW,
    NewPermission.LOAN_QUOTES_CREATE,
    NewPermission.LOAN_QUOTES_EDIT,
    NewPermission.LOAN_QUOTES_DELETE,
    NewPermission.LOAN_QUOTES_MANAGE_ADD_FORM,
    NewPermission.LOAN_QUOTES_MANAGE_LAYOUT,
    NewPermission.LOAN_QUOTES_PUBLIC_CUSTOM_VIEWS,
    NewPermission.LOAN_QUOTES_SHARING_RECORDS,
  ],
  [Module.LEASES]: [
    NewPermission.LEASES_VIEW,
    NewPermission.LEASES_CREATE,
    NewPermission.LEASES_EDIT,
    NewPermission.LEASES_DELETE,
    NewPermission.LEASES_MANAGE_ADD_FORM,
    NewPermission.LEASES_MANAGE_LAYOUT,
    NewPermission.LEASES_PUBLIC_CUSTOM_VIEWS,
    NewPermission.LEASES_SHARING_RECORDS,
  ],
  [Module.DISPOSITIONS]: [
    NewPermission.DISPOSITIONS_VIEW,
    NewPermission.DISPOSITIONS_CREATE,
    NewPermission.DISPOSITIONS_EDIT,
    NewPermission.DISPOSITIONS_DELETE,
    NewPermission.DISPOSITIONS_MANAGE_ADD_FORM,
    NewPermission.DISPOSITIONS_MANAGE_LAYOUT,
    NewPermission.DISPOSITIONS_PUBLIC_CUSTOM_VIEWS,
    NewPermission.DISPOSITIONS_SHARING_RECORDS,
  ],
  [Module.CONTACTS]: [
    NewPermission.CONTACTS_CREATE,
    NewPermission.CONTACTS_EDIT,
    NewPermission.CONTACTS_VIEW,
    NewPermission.CONTACTS_DELETE,
    NewPermission.CONTACTS_MANAGE_ADD_FORM,
    NewPermission.CONTACTS_MANAGE_LAYOUT,
    NewPermission.CONTACTS_SHARING_RECORDS,
  ],
  [Module.COMPANIES]: [
    NewPermission.COMPANIES_VIEW,
    NewPermission.COMPANIES_CREATE,
    NewPermission.COMPANIES_EDIT,
    NewPermission.COMPANIES_DELETE,
    NewPermission.COMPANIES_MANAGE_ADD_FORM,
    NewPermission.COMPANIES_MANAGE_LAYOUT,
    NewPermission.COMPANIES_PUBLIC_CUSTOM_VIEWS,
    NewPermission.COMPANIES_SHARING_RECORDS,
  ],
  [Module.TASKS]: [
    NewPermission.GLOBAL_TASK_LISTS_VIEW,
    NewPermission.GLOBAL_TASK_LISTS_CREATE,
    NewPermission.GLOBAL_TASK_LISTS_EDIT,
    NewPermission.GLOBAL_TASK_LISTS_DELETE,
    NewPermission.GLOBAL_TASK_LISTS_MANAGE_ADD_FORM,
    NewPermission.GLOBAL_TASKS_SHARING_RECORDS,
    NewPermission.AGGREGATED_TASK_LISTS_VIEW,
    NewPermission.AGGREGATED_TASK_LISTS_CREATE,
    NewPermission.AGGREGATED_TASK_LISTS_EDIT,
    NewPermission.AGGREGATED_TASK_LISTS_DELETE,
    NewPermission.AGGREGATED_TASK_LISTS_MANAGE_ADD_FORM,
    NewPermission.AGGREGATED_TASKS_PUBLIC_CUSTOM_VIEWS,
    NewPermission.AGGREGATED_TASKS_SHARING_RECORDS,
  ],
  [Module.PROPERTIES]: [
    NewPermission.PROPERTIES_VIEW,
    NewPermission.PROPERTIES_CREATE,
    NewPermission.PROPERTIES_EDIT,
    NewPermission.PROPERTIES_DELETE,
    NewPermission.PROPERTIES_MANAGE_ADD_FORM,
    NewPermission.PROPERTIES_MANAGE_LAYOUT,
    NewPermission.PROPERTIES_PUBLIC_CUSTOM_VIEWS,
    NewPermission.PROPERTIES_SHARING_RECORDS,
  ],
  // No new permissions for maps
  [Module.MAPS]: [],
  [Module.CUSTOM_OBJECTS]: [],
  [Module.REPORTS]: [
    NewPermission.DASHBOARDS_CREATE,
    NewPermission.DASHBOARDS_EDIT,
    NewPermission.DASHBOARDS_DELETE,
    NewPermission.DASHBOARDS_VIEW,
    NewPermission.DASHBOARDS_SHARING_RECORDS,
    NewPermission.REPORT_BUILDER_CREATE,
    NewPermission.REPORTS_BUILDER_EDIT,
    NewPermission.REPORT_BUILDER_SHARING_RECORDS,
    NewPermission.REPORTS_BUILDER_VIEW,
    NewPermission.REPORTS_BUILDER_DELETE,
    NewPermission.PDF_REPORTS_CREATE,
    NewPermission.PDF_REPORTS_EDIT,
    NewPermission.PDF_REPORTS_DELETE,
    NewPermission.PDF_REPORTS_VIEW,
    NewPermission.PDF_REPORTS_SHARING_RECORDS,
  ],
  [Module.SETTINGS]: [
    NewPermission.SETTINGS_MANAGE_WORKSPACE,
    NewPermission.SETTINGS_MANAGE_USERS,
    NewPermission.SETTINGS_MANAGE_TEAMS,
    NewPermission.SETTINGS_MANAGE_PERMISSIONS,
    NewPermission.SETTINGS_MANAGE_ROLES,
    NewPermission.SETTINGS_MANAGE_DROPDOWNS,
    NewPermission.SETTINGS_MANAGE_OBJECTS_MANAGER,
    NewPermission.SETTINGS_MANAGE_FIELDS,
    NewPermission.SETTINGS_MANAGE_TASK_TEMPLATES,
    NewPermission.SETTINGS_MANAGE_SHEETS,
    NewPermission.SETTINGS_MANAGE_APPS,
    NewPermission.SETTINGS_MANAGE_CODE,
    NewPermission.SETTINGS_MANAGE_IMPORTS,
    NewPermission.SETTINGS_MANAGE_AUTOMATIONS,
    NewPermission.SETTINGS_MANAGE_EXPORTS,
    NewPermission.SETTINGS_MANAGE_ACCOUNT_HOOKS,
    NewPermission.SETTINGS_MANAGE_LAYOUTS,
    NewPermission.SETTINGS_MANAGE_AUDIT,
    NewPermission.SETTINGS_MANAGE_BUDGET_BUILDER_TEMPLATES,
  ],
  [Module.ETHAN]: [],
};
